import React from 'react'

function Forgotpassword() {
    return (
        <div className='forgotpassword'>
            <div className="other_overlay"></div>
            
        </div>
    )
}

export default Forgotpassword
